/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
function amountCheck(intervalConf, value) {
  const isInterval = intervalConf.match(/^[[\]](\d+|Inf),/);
  const isValues = intervalConf.match(/^{/);

  if (isInterval) {
    return checkInterval(intervalConf, value);
  } else if (isValues) {
    return checkValues(intervalConf, value);
  }

  return false;
}

function checkInterval(interval, value) {
  const match = interval.match(/^([[\]])(\d+|Inf),(\d+|Inf)+([[\]])/);
  const isStartExcluded = match[1] !== '[';
  const isEndExcluded = match[4] !== ']';
  let startValue = match[2] === 'Inf' ? -Infinity : +match[2];
  let endValue = match[3] === 'Inf' ? Infinity : +match[3];

  if (isStartExcluded) {
    startValue++;
  }

  if (isEndExcluded) {
    endValue--;
  }

  return value >= startValue && value <= endValue;
}

function checkValues(interval, value) {
  const values = interval.match(/^\{(.*)\}/)[1].split('|');
  const numericValues = values.map((value) => +value);

  return numericValues.includes(value);
}

export default amountCheck;
